import './styles.scss'
import React from 'react'
import PropTypes from 'prop-types'

import { getStaticImage } from 'utils/statics'

const ReactionIcons = ({ reactions = [], withBackground = false }) => {
  if (!reactions.length) return null

  return (
    <div
      className='reaction-icons'
      style={{
        backgroundColor: withBackground ? '#ffffff' : 'transparent',
        boxShadow: withBackground ? '0 2px 4px 0 rgba(0, 0, 0, .13)' : 'initial'
      }}
    >
      <div className='reaction-icons__icons-container'>
        {reactions.map((reaction, index) => (
          <figure key={index} className='reaction-icons__icon'>
            <img src={getStaticImage(`/icons/orange-brand/${reaction.typeReaction.toLowerCase()}.png`)} alt={reaction.typeReaction} />
          </figure>
        ))}
      </div>
      <span className='reaction-icons__count'>
        {reactions.reduce((accumulator, object) => accumulator + object.totalCount, 0)}
      </span>
    </div>
  )
}

ReactionIcons.propTypes = {
  reactions: PropTypes.array,
  withBackground: PropTypes.bool
}

export default ReactionIcons
